import { toast } from 'react-toastify';

export function getSessionId() {
  return localStorage.getItem('safeSessionId') || sessionStorage.getItem('safeSessionId');
}

export function setSessionId(sessionId) {
  if (sessionId) {
    localStorage.setItem('safeSessionId', sessionId);
    sessionStorage.setItem('safeSessionId', sessionId);
  }
}

export function clearSessionId() {
  localStorage.removeItem('safeSessionId');
  sessionStorage.removeItem('safeSessionId');
}

export function handleUnauthorized(options = {}) {
  console.log("Session expired or unauthorized. Clearing session data...");

  toast.error("Your session has expired. Please sign in again.", {
    autoClose: 4000,
    closeOnClick: true,
  });

  clearSessionId();
  localStorage.removeItem("username");
  localStorage.clear();
  sessionStorage.clear();

  const cookieNames = ['SAFE_SESSIONID', 'sessionId', 'session', 'authToken'];
  const domains = [
    window.location.hostname,
    '.profitree-tax.com',
    '.profitree-backend-9482feeffc4a.herokuapp.com',
    'profitree-backend-9482feeffc4a.herokuapp.com'
  ];

  cookieNames.forEach(cookieName => {
    domains.forEach(domain => {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 01 1970 00:00:00 UTC; path=/; domain=${domain}; secure;`;
    });
  });

  const cookies = document.cookie.split(";");
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
  });

  if (options?.suppressRedirect) return;

  const currentPath = window.location.pathname;
  const redirectExemptPaths = ['/auth', '/', '/reset-password', '/signup', '/verify-email', '/pricing', '/blog', '/about', '/contact', '/terms', '/privacy'];
  const shouldRedirect = !redirectExemptPaths.some(path => currentPath === path);

  if (shouldRedirect) {
    console.log("Redirecting to login page...");
    setTimeout(() => {
      window.location.href = '/auth';
    }, 1500);
  }
}